import React from 'react';
import * as _ from 'lodash';
import axios from 'axios';
import {combineReducers} from 'redux';
import {connect} from 'react-redux';

class CheckboxEditor extends React.Component {

  onChange = (e) => {
    const {props} = this;
    props.onChange({
      fromRow: this.props.rowIdx,
      toRow: this.props.rowIdx,
      updated: {
        [this.props.column.key]: e.target.checked,
      },
    });
    console.log('checkboxeditor changed');
  };

  render() {
    const {props} = this;
    return (
        <div>
          <input type={'checkbox'}
                 checked={props.value == 1}
                 onChange={this.onChange} />
        </div>
    );
  }
}

export default connect(
    (state, props) => ({...state, ...props}),
)(CheckboxEditor);


// WEBPACK FOOTER //
// ./src/component/element/CarDamageForm/Editors/CheckboxEditor.js